<template>
  <div>
    <board-page />
  </div>
</template>

<script>
import BoardPage from "../../components/apply/BoardComp.vue";

export default {
  name: "CalendarView",

  components: {
    BoardPage,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
